export const AUTOMATIONS_TAB_VALUES = {
  allAutomations: 'automations',
  history: 'history',
} as const;

export type AutomationsTabValue =
  (typeof AUTOMATIONS_TAB_VALUES)[keyof typeof AUTOMATIONS_TAB_VALUES];

export const AUTOMATIONS_DEFAULT_TAB_VALUE =
  AUTOMATIONS_TAB_VALUES.allAutomations;

export const isAutomationsTabValue = (
  value: string
): value is AutomationsTabValue =>
  Object.values(AUTOMATIONS_TAB_VALUES).includes(value as AutomationsTabValue);
